export default __webpack_public_path__ + "static/media/ag_8.58a6a327.wav";